const HOME_ASSISTANT_PLACEHOLDER_TEMPLATE_IDS = new Set([
  "ha-current-entity-state",
  "ha-history-placeholder",
]);

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function isHomeAssistantPlaceholderDataSource(dataSource: unknown): boolean {
  if (!isRecord(dataSource)) return false;

  return (
    dataSource.type === "home-assistant-placeholder" ||
    (dataSource.source === "home-assistant" &&
      (dataSource.mode === "placeholder" || dataSource.execution === "none"))
  );
}

export function isHomeAssistantPlaceholderTemplateId(templateId: unknown): boolean {
  return (
    typeof templateId === "string" &&
    HOME_ASSISTANT_PLACEHOLDER_TEMPLATE_IDS.has(templateId)
  );
}

export function isInertHomeAssistantPlaceholderBinding(
  dataSource: unknown,
  templateId?: string,
): boolean {
  return (
    isHomeAssistantPlaceholderDataSource(dataSource) ||
    (isHomeAssistantPlaceholderTemplateId(templateId) && !isRecord(dataSource))
  );
}
